import React, { Component } from 'react'
import axios from 'axios'
import {sortBy} from 'lodash'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import '../src/Stylesheets/app.css'

const DEFAULT_QUERY = 'redux'
const DEFAULT_HPP = '15'

const PATH_BASE = 'https://hn.algolia.com/api/v1'
const PATH_SEARCH = '/search'
const PARAM_SEARCH = 'query='
const PARAM_PAGE = 'page='
const PARAM_HPP = 'hitsPerPage='

const SORTS = {
  NONE: list => list,
  TITLE: list => sortBy(list, 'title'),
  AUTHOR: list => sortBy(list, 'author'),
  COMMENTS: list => sortBy(list, 'num_comments').reverse(),
  POINTS: list => sortBy(list, 'points').reverse(),
}
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      results: null,
      searchKey: '',
      searchTerm: DEFAULT_QUERY,
      error: null,
      loading: false,
    }
    this.needsToSearchTopStories = this.needsToSearchTopStories.bind(this)
    this.setSearchTopStories = this.setSearchTopStories.bind(this)
    this.fetchSearchTopStories = this.fetchSearchTopStories.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.onDismiss = this.onDismiss.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
  }

  needsToSearchTopStories(searchTerm) {
    return !this.state.results[searchTerm]
  }

  // Search top stories
  setSearchTopStories(result) {
    const { hits, page } = result

    this.setState(prevState => {
      const { searchKey, results} = this.state

      const oldHits = results && results[searchKey]
        ? results[searchKey].hits
        : []
      
      const updatedHits = [
        ...oldHits,
        ...hits
      ]
      return {
        results: {
          ...results,
          [searchKey]: {hits: updatedHits, page}
        },
        isLoading: false
      }
    })
  }

  // When component mounted, fetch data.
  componentDidMount() {
    const {searchTerm} = this.state
    this.setState({searchKey: searchTerm})
    this.fetchSearchTopStories(searchTerm)
  }

  // Delete entry method
  onDismiss(id) {
    const {searchKey, results} = this.state
    const {hits, page} = results[searchKey]

    const isNotId = item => item.objectID !== id
    const updatedHits = hits.filter(isNotId)

    this.setState({
      results: {
        ...results,
        [searchKey]: {hits: updatedHits, page}}
    })
  }

  // Change search term on change of input field
  onSearchChange(event) {
    this.setState({searchTerm: event.target.value})
  }

  // On search submit method
  onSearchSubmit(event) {
    const {searchTerm} = this.state
    this.setState({searchKey: searchTerm})

    if(this.needsToSearchTopStories(searchTerm)) {
      this.fetchSearchTopStories(searchTerm)
    }
    event.preventDefault()
  }

  // Fetch top stories 
  fetchSearchTopStories(searchTerm, page = 0) {
    this.setState({isLoading: true})
    axios(`${PATH_BASE}${PATH_SEARCH}?${PARAM_SEARCH}${searchTerm}&${PARAM_PAGE}${page}&${PARAM_HPP}${DEFAULT_HPP}`)
      .then(result => this.setSearchTopStories(result.data))
      .catch(error => this.setState({error}))
  }

  render() {
    const {searchTerm, results, searchKey, error, isLoading} = this.state
    const page = (results && results[searchKey] && results[searchKey].page) || 0
    const list = (results && results[searchKey] && results[searchKey].hits) || []
    return (
      <div className='page'>
        <div className='interactions'>
          <div>
            <Search
              value={searchTerm}
              onChange={this.onSearchChange}
              onSubmit={this.onSearchSubmit}
            >
            Search
            </Search>
          </div>
          <div>
            <ButtonWithLoading
              isLoading={isLoading}
              onClick={()=>this.fetchSearchTopStories(searchKey, page+1)}
            >
              More
            </ButtonWithLoading>
          </div>
        </div>
        {error 
          // Show error with class interactions if error is true
          ? <div className='interactions'>
            <p>Something went wrong</p>
          </div>
          // Else show a the list of items
          : <Table 
            list={list}
            onDismiss={this.onDismiss}
          />
        }
      </div>
    )
  }
}

// Loading componenet 
const withLoadng = (Componenet) => ({isLoading, ...rest}) => 
  isLoading
    ? <Loading/>
    : <Componenet {...rest} 
/>
const ButtonWithLoading = withLoadng(Button)

function Loading() {
  return (
    <button>Loading...</button>
  )
}
// Search componenet
class Search extends React.Component {
    componentDidMount() {
      if(this.input) {
        this.input.focus()
      }
    }
    render() {
      const {
        onSubmit,
        children,
        value,
        onChange,
      } = this.props

      return (
        <form onSubmit={onSubmit}>
        {children}
        <input 
          type='text'
          value={value}
          onChange={onChange}
          ref={el => this.input = el}
        />
        <button type='submit'>
          Submit
        </button>
      </form>
      )
    }
}
// Search component propTypes
Search.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

// Sort componenet
function Sort(props) {
  const sortClass = classNames(
    'button-inline',
    {'button-active': props.sortKey === props.activeSortKey}
  )

  return (
    <Button
      onClick={() => props.onSort(props.sortKey)}
      className={sortClass}
    >
    {props.children}
    </Button>
  )
}
// Table componenet
class Table extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortKey: 'NONE',
      isSortReverse: false,
    }
    this.onSort = this.onSort.bind(this)
  }

  //Sort method
  onSort(sortKey) {
    const isSortReverse = this.state.sortKey === sortKey && !this.state.isSortReverse;
    this.setState({sortKey, isSortReverse})
  }

  render() {
    const sortedList = SORTS[this.state.sortKey](this.props.list)
    const reverseSortedList = this.state.isSortReverse
      ? sortedList.reverse()
      : sortedList
    
    
    return(

      <div className='table'>
        <div className='table-header'>
          <span style={{width: '60%'}}><Sort sortKey={'TITLE'} onSort={this.onSort} activeSortKey={this.state.sortKey}>Title</Sort></span>
          <span style={{width: '10%'}}><Sort sortKey={'AUTHOR'} onSort={this.onSort} activeSortKey={this.state.sortKey}>Author</Sort></span>
          <span style={{width: '10%'}}><Sort sortKey={'COMMENTS'} onSort={this.onSort} activeSortKey={this.state.sortKey}>Comments</Sort></span>
          <span style={{width: '10%'}}><Sort sortKey={'POINTS'} onSort={this.onSort} activeSortKey={this.state.sortKey}>Points</Sort></span>
          <span style={{width: '10%'}}></span>
        </div>

        {reverseSortedList.map(item =>
          <div key={item.objectID} className='table-row'>
            <span style={{width: '60%'}}><a href={item.url}>{item.title}</a></span>
            <span style={{width: '10%'}}>{item.author}</span>
            <span style={{width: '10%'}}>{item.num_comments}</span>
            <span style={{width: '10%'}}>{item.points}</span>
            <span style={{width: '10%'}}>
            <Button
              onClick={()=> this.props.onDismiss(item.objectID)}
            >
              Dismiss
            </Button>
            </span>
            </div>
        )}
      </div>

    )
  }
}
// Table component propTypes
Table.propTypes = {
  list: PropTypes.array.isRequired,
  onDismiss: PropTypes.func.isRequired,
}

// Button componenet
function Button(props) {
  return(
    <button
      onClick={props.onClick}
      className={props.className}
      type='button'
    >
      {props.children}
    </button>
  )
}
// Button component propTypes
Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default App

export {
  Button,
  Search,
  Table,
}